import React from "react";
import { FaTimes } from "react-icons/fa";
import { FaSearch } from "react-icons/fa";

export default function SearchBox({
                                      searchBoxRef,
                                      hideSearchBox,
                                      searchInput,
                                      setSearchInput,
                                      showSearchResults,
                                      setSearchResultsVisible,
                                      searchResults,
                                      searchResultsVisible,
                                      recentSearches,
                                      performSearchBox,
                                      selectSearchResult,
                                  }) {
    return (
        <div
            ref={searchBoxRef}
            id="search-box"
            className="bg-white border border-gray-200 rounded-xl mx-4 mt-4 p-4 shadow-lg transform transition-all duration-300 relative z-[20]"
            style={{ marginTop: "80px" }}
        >
            <div className="flex items-center justify-between mb-3">
                <button
                    onClick={hideSearchBox}
                    className="text-gray-400 hover:text-gray-600"
                >
                    <FaTimes size={18} className=" text-lg"></FaTimes>
            
                </button>
                <h3 className="text-lg font-bold text-gray-900">Search Signals</h3>
                <div></div>
            </div>
            <div className="relative mb-4">
                <input
                    id="search-input-box"
                    value={searchInput}
                    onChange={(e) => {
                        setSearchInput(e.target.value);
                        if (e.target.value.trim().length > 2)
                            showSearchResults(e.target.value.trim());
                        else setSearchResultsVisible(false);
                    }}
                    type="text"
placeholder="Search by signal type or description..."                    className="w-full pl-12 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                />
<FaSearch
    size={18}
    className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400"
/>            </div>

            <div
                id="search-results"
                className={`${searchResultsVisible ? "" : "hidden"} space-y-3 mb-4 max-h-60 overflow-y-auto`}
            >
                <div className="text-sm font-semibold text-gray-700 px-2">
                    Search Results
                </div>
                {searchResults.length === 0 ? (
                    <div className="text-sm text-gray-500 px-2 py-3 text-center">
                        No results found
                    </div>
                ) : (
                  searchResults.map((r) => (
  <div
    key={r._id}
    onClick={() => selectSearchResult("signal", r._id)}
    className="flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 cursor-pointer transition-colors"
  >
    <div className="flex items-center min-w-0">
      <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3 shrink-0">
        <FaSearch className="text-blue-600 text-sm" />
      </div>

      <div className="min-w-0">
        <p className="font-semibold text-sm">
          {r.symbol?.symbol ?? r.symbol?.name ?? "Signal"}
          {" · "}
          {r.type?.toUpperCase() ?? "—"}
        </p>

        <p className="text-xs text-gray-500 truncate">
          {r.description || "No description"}
        </p>
      </div>
    </div>

    <span
      className={`text-xs px-2 py-1 rounded-full shrink-0 ${
        ["active", "completed"].includes(
          r.status?.toLowerCase()
        )
          ? "bg-green-100 text-green-600"
          : "bg-red-100 text-red-600"
      }`}
    >
      {r.status ?? "—"}
    </span>
  </div>
))
                )}
            </div>

            <div className="space-y-4">
                <div>
                    <h4 className="text-sm font-medium text-gray-700 mb-3">
                        Recent Searches
                    </h4>
                    <div id="recent-searches" className="space-y-2">
                        {recentSearches.map((s, i) => (
                            <button
                                key={i}
                               onClick={() => {
    setSearchInput(s);
    showSearchResults(s);
}}
                                className="w-full text-left p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors flex items-center justify-between"
                            >
                                <span className="text-gray-600">{s}</span>
                                <i className="fas fa-clock text-gray-400 text-xs"></i>
                            </button>
                        ))}
                    </div>
                </div>
            </div>

            <button
                onClick={performSearchBox}
                className="w-full mt-4 bg-primary hover:bg-accent text-white py-3 rounded-xl font-medium transition-colors"
            >
                Search Signals
            </button>
        </div>
    );
}
